module.exports = __webpack_public_path__ + "media/images/icons/outlined/radar-chart-0a96eac07ddc43ccfa3e172ac409123e.svg";